<template>
  <el-dialog v-if="dataInfo !== null" :title="title" @closed="_closed" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false">
    <div style="padding: 20px;">
      <el-form ref="formRef" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="工人姓名" required prop="worker_name">
          <el-input v-model="formData.worker_name" placeholder="请输入工人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required prop="worker_phone">
          <el-input v-model="formData.worker_phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="关联系统用户">
          <lgh-select-user v-model="formData.user_id" placeholder="可选择关联小程序用户"></lgh-select-user>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="formData.is_enabled"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancel">取 消</el-button>
      <el-button type="primary" @click="_submit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store'
export default {
  name: 'CleanWorkerEdit',
  computed: {
    userInfo() {
      return store.state.userInfo
    }
  },
  data() {
    return {
      title: '',
      visible: true,
      isAdd: true,
      dataInfo: null,
      formData: {
        worker_id: 0,
        enterprise_code: '',
        worker_name: '',
        worker_phone: '',
        user_id: null,
        is_enabled: true,
        create_time: '2000-01-01 00:00:00',
        create_user_id: null,
        create_user_name: '',
        remark: ''
      },
      rules: {
        worker_name: [
          { required: true, message: '请输入工人姓名', trigger: 'blur' }
        ],
        worker_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    if (this.dataInfo && !this.isAdd) {
      Object.assign(this.formData, this.dataInfo)
    }
  },
  mounted() {
    if (this.dataInfo && !this.isAdd) {
      Object.assign(this.formData, this.dataInfo)
    }
  },
  methods: {
    _closed() {
      this.onclosed()
    },
    _cancel() {
      this.visible = false
      this.cancel && this.cancel()
    },
    async _submit() {
      const result = await this.submit()
      if (result === true) {
        this.visible = false
        this.onsuccess && this.onsuccess(result)
      }
    },
    async submit() {
      let valid = false
      await this.$refs.formRef.validate((result) => {
        valid = result
      })
      if (!valid) {
        return false
      }

      this.formData.enterprise_code = this.userInfo.enterpriseCode
      this.formData.create_user_id = this.userInfo.userId
      this.formData.create_user_name = this.userInfo.fullName

      if (this.isAdd) {
        await this.$lgh.post('api/clean/worker/add', this.formData)
      } else {
        await this.$lgh.post('api/clean/worker/update', this.formData)
      }
      return true
    }
  }
}
</script>
